// AUTO-GENERATED by scripts/fetch-cms-content.mjs (privacy policy + consent.* blocks → CMS).
// Gitignored — do NOT edit or commit.
/* eslint-disable */
export const CMS_COOKIE_BANNER_REVISION: number = 1;
export const CMS_CONSENT_COPY: Record<string, Record<string, string>> = {
  "en": {
    "acceptAll": "Accept all",
    "adsClick": "Links a signup back to the advertisement it came from.",
    "adsFromAd": "Set when you arrive from a Google advertisement, and ties this visit to it.",
    "analyticsBody": "Help us see which pages are used and where visitors get stuck, so we can improve them. This includes recordings of how a page is used, with anything you type masked, and measurements that also reach our Google Ads account.",
    "analyticsTitle": "Analytics",
    "clarityId": "Recognises your browser across the sites that use Clarity, the service that makes those measurements.",
    "claritySession": "Marks the visit you are in now.",
    "clarityVisitor": "Recognises your browser between visits, so we can see where people get stuck.",
    "close": "Close",
    "colExpiry": "Expiry",
    "colName": "Name",
    "colPurpose": "Purpose",
    "consentCookie": "Your cookie choices.",
    "description": "Some cookies are needed for the site to work. With your permission we would also use them to understand how the site is used and for our advertising.",
    "expiry12m": "12 months",
    "expiry13m": "13 months",
    "expiry15min": "15 minutes",
    "expiry1d": "1 day",
    "expiry24m": "24 months",
    "expiry6m": "6 months",
    "expiry90d": "90 days",
    "expiryStorage": "Local storage, until cleared",
    "gaSession": "Keeps one visit together, so pages read one after another count once.",
    "gaVisitor": "Whether you have been here before, so a returning visitor is not counted as a new one.",
    "introBody": "Necessary cookies are always on, because the site cannot work without them. Everything else stays off until you turn it on, and you can change your choice at any time.",
    "introTitle": "How we use cookies",
    "localeCookie": "The language you chose for the site.",
    "manage": "Manage preferences",
    "marketingBody": "Used to measure which of our advertisements lead to a signup, and to show our advertisements to people who have visited us, on other sites too. After you register, a hashed form of your e-mail address is used to match the signup to an advertisement.",
    "marketingTitle": "Advertising",
    "metaBrowser": "Recognises your browser, so we can measure our advertising on Facebook and Instagram and show our advertisements there to people who have visited us.",
    "metaClick": "Set when you arrive from an advertisement on Facebook or Instagram.",
    "necessaryBody": "Remember the language you chose, keep the signup you are completing, and store your cookie choice. These cannot be switched off.",
    "necessaryTitle": "Strictly necessary",
    "prefTitle": "Cookie preferences",
    "preferencesBody": "Remember optional choices you make, so the site behaves the way you left it. They also keep your support-chat conversation, so you can pick it up where you left off.",
    "preferencesTitle": "Preferences",
    "rejectAll": "Reject non-essential",
    "remarketingId": "Recognises your browser on other sites, so we can show our advertisements to people who have visited us.",
    "remarketingProbe": "Checks whether your browser accepts advertising cookies at all.",
    "save": "Save preferences",
    "signupState": "The signup you are part-way through.",
    "supportChat": "Your support-chat conversation, so it continues where you left off.",
    "title": "We use cookies"
  },
  "nl": {
    "acceptAll": "Alles accepteren",
    "adsClick": "Koppelt een registratie aan de advertentie waar die vandaan kwam.",
    "adsFromAd": "Geplaatst wanneer u via een Google-advertentie binnenkomt, en koppelt dit bezoek eraan.",
    "analyticsBody": "Helpen ons te zien welke pagina’s worden gebruikt en waar bezoekers vastlopen, zodat we ze kunnen verbeteren.",
    "analyticsTitle": "Analytisch",
    "clarityId": "Geplaatst door clarity.ms, de dienst die deze metingen doet.",
    "claritySession": "Markeert het bezoek waarin u nu bent.",
    "clarityVisitor": "Herkent uw browser tussen bezoeken, zodat we zien waar bezoekers vastlopen.",
    "close": "Sluiten",
    "colExpiry": "Vervalt",
    "colName": "Naam",
    "colPurpose": "Doel",
    "consentCookie": "Uw cookiekeuzes.",
    "description": "Sommige cookies zijn nodig om de site te laten werken. Met uw toestemming gebruiken we ze ook om te begrijpen hoe de site wordt gebruikt en om onze marketing te meten.",
    "expiry12m": "12 maanden",
    "expiry13m": "13 maanden",
    "expiry15min": "15 minuten",
    "expiry1d": "1 dag",
    "expiry24m": "24 maanden",
    "expiry6m": "6 maanden",
    "expiry90d": "90 dagen",
    "expiryStorage": "Lokale opslag, tot u het wist",
    "gaSession": "Houdt één bezoek bij elkaar, zodat pagina’s na elkaar als één bezoek tellen.",
    "gaVisitor": "Of u hier eerder bent geweest, zodat een terugkerende bezoeker niet als nieuw wordt geteld.",
    "introBody": "Noodzakelijke cookies staan altijd aan, omdat de site zonder deze niet werkt. Al het andere blijft uit tot u het aanzet, en u kunt uw keuze altijd wijzigen.",
    "introTitle": "Hoe we cookies gebruiken",
    "localeCookie": "De taal die u voor de site koos.",
    "manage": "Voorkeuren beheren",
    "marketingBody": "Gebruikt om onze advertenties te meten en om inhoud te tonen die voor u relevant is.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Herkent uw browser, zodat we onze advertenties op Facebook en Instagram kunnen meten.",
    "metaClick": "Geplaatst wanneer u via een advertentie op Facebook of Instagram binnenkomt.",
    "necessaryBody": "Onthouden welke taal u koos, de registratie die u aan het invullen bent bewaren, en uw cookiekeuze opslaan. Deze kunnen niet worden uitgeschakeld.",
    "necessaryTitle": "Strikt noodzakelijk",
    "prefTitle": "Cookievoorkeuren",
    "preferencesBody": "Onthouden optionele keuzes die u maakt, zodat de site werkt zoals u hem achterliet. Ze bewaren ook uw supportchat-gesprek, zodat u verder kunt waar u gebleven was.",
    "preferencesTitle": "Voorkeuren",
    "rejectAll": "Niet-essentiële weigeren",
    "remarketingId": "Herkent uw browser op andere sites, zodat we onze advertenties kunnen tonen aan mensen die ons hebben bezocht.",
    "remarketingProbe": "Controleert of uw browser advertentiecookies überhaupt accepteert.",
    "save": "Voorkeuren opslaan",
    "signupState": "De registratie die u aan het afronden bent.",
    "supportChat": "Uw supportchatgesprek, zodat het verdergaat waar u gebleven was.",
    "title": "We gebruiken cookies"
  },
  "fr-be": {
    "acceptAll": "Tout accepter",
    "adsClick": "Relie une inscription à l'annonce dont elle provient.",
    "adsFromAd": "Déposé lorsque vous arrivez via une annonce Google, et relie cette visite à celle-ci.",
    "analyticsBody": "Nous aident à voir quelles pages sont utilisées et où les visiteurs bloquent, afin de les améliorer.",
    "analyticsTitle": "Analytiques",
    "clarityId": "Déposé par clarity.ms, le service qui effectue ces mesures.",
    "claritySession": "Marque la visite en cours.",
    "clarityVisitor": "Reconnaît votre navigateur d'une visite à l'autre, pour voir où les visiteurs bloquent.",
    "close": "Fermer",
    "colExpiry": "Expiration",
    "colName": "Nom",
    "colPurpose": "Finalité",
    "consentCookie": "Vos choix de cookies.",
    "description": "Certains cookies sont nécessaires au fonctionnement du site. Avec votre accord, nous les utiliserions aussi pour comprendre comment le site est utilisé et pour mesurer notre marketing.",
    "expiry12m": "12 mois",
    "expiry13m": "13 mois",
    "expiry15min": "15 minutes",
    "expiry1d": "1 jour",
    "expiry24m": "24 mois",
    "expiry6m": "6 mois",
    "expiry90d": "90 jours",
    "expiryStorage": "Stockage local, jusqu'à effacement",
    "gaSession": "Regroupe une même visite, afin que des pages consultées l'une après l'autre comptent pour une seule.",
    "gaVisitor": "Si vous avez déjà visité le site, afin qu'une visite de retour ne soit pas comptée comme nouvelle.",
    "introBody": "Les cookies nécessaires sont toujours actifs, car le site ne peut pas fonctionner sans eux. Tout le reste reste désactivé tant que vous ne l’activez pas, et vous pouvez modifier votre choix à tout moment.",
    "introTitle": "Comment nous utilisons les cookies",
    "localeCookie": "La langue que vous avez choisie pour le site.",
    "manage": "Gérer les préférences",
    "marketingBody": "Utilisés pour mesurer notre publicité et afficher du contenu qui vous concerne.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Reconnaît votre navigateur, afin de mesurer nos annonces sur Facebook et Instagram.",
    "metaClick": "Déposé lorsque vous arrivez via une annonce sur Facebook ou Instagram.",
    "necessaryBody": "Mémorisent la langue choisie, conservent l’inscription en cours et enregistrent votre choix de cookies. Ils ne peuvent pas être désactivés.",
    "necessaryTitle": "Strictement nécessaires",
    "prefTitle": "Préférences de cookies",
    "preferencesBody": "Mémorisent les choix facultatifs que vous faites, afin que le site reste comme vous l’avez laissé. Ils conservent aussi votre conversation avec le support, pour la reprendre là où vous l’avez laissée.",
    "preferencesTitle": "Préférences",
    "rejectAll": "Refuser les non essentiels",
    "remarketingId": "Reconnaît votre navigateur sur d'autres sites, afin de montrer nos annonces aux personnes qui nous ont visités.",
    "remarketingProbe": "Vérifie si votre navigateur accepte les cookies publicitaires.",
    "save": "Enregistrer les préférences",
    "signupState": "L'inscription que vous êtes en train de compléter.",
    "supportChat": "Votre conversation avec l'assistance, pour la reprendre là où vous l'aviez laissée.",
    "title": "Nous utilisons des cookies"
  },
  "es": {
    "acceptAll": "Aceptar todo",
    "adsClick": "Vincula un registro con el anuncio del que procede.",
    "adsFromAd": "Se establece cuando llega desde un anuncio de Google y vincula esta visita con él.",
    "analyticsBody": "Nos ayudan a ver qué páginas se usan y dónde se atascan los visitantes, para poder mejorarlas.",
    "analyticsTitle": "Analíticas",
    "clarityId": "Lo establece clarity.ms, el servicio que realiza esas mediciones.",
    "claritySession": "Marca la visita actual.",
    "clarityVisitor": "Reconoce su navegador entre visitas, para ver dónde se atascan los visitantes.",
    "close": "Cerrar",
    "colExpiry": "Caducidad",
    "colName": "Nombre",
    "colPurpose": "Finalidad",
    "consentCookie": "Sus preferencias de cookies.",
    "description": "Algunas cookies son necesarias para que el sitio funcione. Con su permiso, también las usaríamos para entender cómo se usa el sitio y para medir nuestro marketing.",
    "expiry12m": "12 meses",
    "expiry13m": "13 meses",
    "expiry15min": "15 minutos",
    "expiry1d": "1 día",
    "expiry24m": "24 meses",
    "expiry6m": "6 meses",
    "expiry90d": "90 días",
    "expiryStorage": "Almacenamiento local, hasta que lo borre",
    "gaSession": "Agrupa una misma visita, para que las páginas vistas seguidas cuenten como una.",
    "gaVisitor": "Si ya ha estado aquí, para que un visitante que vuelve no se cuente como nuevo.",
    "introBody": "Las cookies necesarias están siempre activas, porque el sitio no puede funcionar sin ellas. Todo lo demás permanece desactivado hasta que usted lo active, y puede cambiar su elección en cualquier momento.",
    "introTitle": "Cómo usamos las cookies",
    "localeCookie": "El idioma que eligió para el sitio.",
    "manage": "Gestionar preferencias",
    "marketingBody": "Se usan para medir nuestra publicidad y mostrar contenido que sea relevante para usted.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Reconoce su navegador para medir nuestra publicidad en Facebook e Instagram.",
    "metaClick": "Se establece cuando llega desde un anuncio en Facebook o Instagram.",
    "necessaryBody": "Recuerdan el idioma elegido, conservan el registro que está completando y guardan su elección de cookies. No se pueden desactivar.",
    "necessaryTitle": "Estrictamente necesarias",
    "prefTitle": "Preferencias de cookies",
    "preferencesBody": "Recuerdan las opciones que elija, para que el sitio se comporte como lo dejó. También conservan su conversación con el soporte, para retomarla donde la dejó.",
    "preferencesTitle": "Preferencias",
    "rejectAll": "Rechazar las no esenciales",
    "remarketingId": "Reconoce su navegador en otros sitios, para mostrar nuestros anuncios a quienes nos han visitado.",
    "remarketingProbe": "Comprueba si su navegador acepta cookies publicitarias.",
    "save": "Guardar preferencias",
    "signupState": "El registro que está completando.",
    "supportChat": "Su conversación con soporte, para continuarla donde la dejó.",
    "title": "Usamos cookies"
  },
  "de": {
    "acceptAll": "Alle akzeptieren",
    "adsClick": "Verknüpft eine Registrierung mit der Anzeige, aus der sie stammt.",
    "adsFromAd": "Wird gesetzt, wenn Sie über eine Google-Anzeige kommen, und verknüpft diesen Besuch damit.",
    "analyticsBody": "Helfen uns zu sehen, welche Seiten genutzt werden und wo Besucher hängen bleiben, damit wir sie verbessern können.",
    "analyticsTitle": "Statistik",
    "clarityId": "Von clarity.ms gesetzt, dem Dienst, der diese Messungen durchführt.",
    "claritySession": "Kennzeichnet den aktuellen Besuch.",
    "clarityVisitor": "Erkennt Ihren Browser zwischen Besuchen, damit wir sehen, wo Besucher hängen bleiben.",
    "close": "Schließen",
    "colExpiry": "Ablauf",
    "colName": "Name",
    "colPurpose": "Zweck",
    "consentCookie": "Ihre Cookie-Entscheidungen.",
    "description": "Einige Cookies sind für den Betrieb der Website erforderlich. Mit Ihrer Erlaubnis würden wir sie auch verwenden, um zu verstehen, wie die Website genutzt wird, und um unser Marketing zu messen.",
    "expiry12m": "12 Monate",
    "expiry13m": "13 Monate",
    "expiry15min": "15 Minuten",
    "expiry1d": "1 Tag",
    "expiry24m": "24 Monate",
    "expiry6m": "6 Monate",
    "expiry90d": "90 Tage",
    "expiryStorage": "Lokaler Speicher, bis Sie ihn löschen",
    "gaSession": "Fasst einen Besuch zusammen, damit nacheinander gelesene Seiten als ein Besuch zählen.",
    "gaVisitor": "Ob Sie schon einmal hier waren, damit ein wiederkehrender Besucher nicht als neu gezählt wird.",
    "introBody": "Notwendige Cookies sind immer aktiv, weil die Website ohne sie nicht funktioniert. Alles andere bleibt aus, bis Sie es einschalten, und Sie können Ihre Wahl jederzeit ändern.",
    "introTitle": "Wie wir Cookies verwenden",
    "localeCookie": "Die von Ihnen gewählte Sprache der Website.",
    "manage": "Einstellungen verwalten",
    "marketingBody": "Dienen dazu, unsere Werbung zu messen und Inhalte anzuzeigen, die für Sie relevant sind.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Erkennt Ihren Browser, damit wir unsere Werbung auf Facebook und Instagram messen können.",
    "metaClick": "Wird gesetzt, wenn Sie über eine Anzeige auf Facebook oder Instagram kommen.",
    "necessaryBody": "Merken sich die gewählte Sprache, bewahren die laufende Registrierung und speichern Ihre Cookie-Entscheidung. Sie können nicht deaktiviert werden.",
    "necessaryTitle": "Unbedingt erforderlich",
    "prefTitle": "Cookie-Einstellungen",
    "preferencesBody": "Merken sich optionale Einstellungen, damit die Website so bleibt, wie Sie sie verlassen haben. Sie bewahren auch Ihre Support-Chat-Unterhaltung auf, damit Sie dort weitermachen können, wo Sie aufgehört haben.",
    "preferencesTitle": "Präferenzen",
    "rejectAll": "Nicht notwendige ablehnen",
    "remarketingId": "Erkennt Ihren Browser auf anderen Websites, damit wir unsere Anzeigen Besuchern erneut zeigen können.",
    "remarketingProbe": "Prüft, ob Ihr Browser Werbe-Cookies überhaupt akzeptiert.",
    "save": "Einstellungen speichern",
    "signupState": "Die Registrierung, die Sie gerade abschließen.",
    "supportChat": "Ihre Support-Chat-Unterhaltung, damit sie dort fortgesetzt wird, wo Sie aufgehört haben.",
    "title": "Wir verwenden Cookies"
  },
  "it": {
    "acceptAll": "Accetta tutti",
    "adsClick": "Collega una registrazione all’annuncio da cui proviene.",
    "adsFromAd": "Impostato quando arriva da un annuncio Google e collega questa visita a quell’annuncio.",
    "analyticsBody": "Ci aiutano a vedere quali pagine vengono usate e dove i visitatori si bloccano, per poterle migliorare.",
    "analyticsTitle": "Analitici",
    "clarityId": "Impostato da clarity.ms, il servizio che effettua queste misurazioni.",
    "claritySession": "Contrassegna la visita in corso.",
    "clarityVisitor": "Riconosce il suo browser tra una visita e l’altra, per vedere dove i visitatori si bloccano.",
    "close": "Chiudi",
    "colExpiry": "Scadenza",
    "colName": "Nome",
    "colPurpose": "Finalità",
    "consentCookie": "Le sue scelte sui cookie.",
    "description": "Alcuni cookie sono necessari al funzionamento del sito. Con il suo consenso li useremmo anche per capire come viene usato il sito e per misurare il nostro marketing.",
    "expiry12m": "12 mesi",
    "expiry13m": "13 mesi",
    "expiry15min": "15 minuti",
    "expiry1d": "1 giorno",
    "expiry24m": "24 mesi",
    "expiry6m": "6 mesi",
    "expiry90d": "90 giorni",
    "expiryStorage": "Archiviazione locale, fino alla cancellazione",
    "gaSession": "Tiene insieme una visita, così le pagine lette una dopo l’altra contano come una.",
    "gaVisitor": "Se ha già visitato il sito, così una visita di ritorno non viene contata come nuova.",
    "introBody": "I cookie necessari sono sempre attivi, perché senza di essi il sito non funziona. Tutto il resto resta disattivato finché non lo attiva lei, e può cambiare scelta in qualsiasi momento.",
    "introTitle": "Come usiamo i cookie",
    "localeCookie": "La lingua che ha scelto per il sito.",
    "manage": "Gestisci preferenze",
    "marketingBody": "Servono a misurare la nostra pubblicità e a mostrare contenuti rilevanti per lei.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Riconosce il suo browser, per misurare la nostra pubblicità su Facebook e Instagram.",
    "metaClick": "Impostato quando arriva da un annuncio su Facebook o Instagram.",
    "necessaryBody": "Ricordano la lingua scelta, conservano la registrazione in corso e salvano la sua scelta sui cookie. Non possono essere disattivati.",
    "necessaryTitle": "Strettamente necessari",
    "prefTitle": "Preferenze sui cookie",
    "preferencesBody": "Ricordano le scelte facoltative che effettua, così il sito resta come l’ha lasciato. Conservano anche la sua conversazione con l’assistenza, così può riprenderla da dove l’ha lasciata.",
    "preferencesTitle": "Preferenze",
    "rejectAll": "Rifiuta i non essenziali",
    "remarketingId": "Riconosce il suo browser su altri siti, per mostrare i nostri annunci a chi ci ha visitato.",
    "remarketingProbe": "Verifica se il suo browser accetta i cookie pubblicitari.",
    "save": "Salva preferenze",
    "signupState": "La registrazione che sta completando.",
    "supportChat": "La sua conversazione con l’assistenza, per riprenderla da dove l’aveva lasciata.",
    "title": "Usiamo i cookie"
  },
  "pt": {
    "acceptAll": "Aceitar tudo",
    "adsClick": "Liga um registo ao anúncio de onde veio.",
    "adsFromAd": "Definido quando chega através de um anúncio Google e liga esta visita a esse anúncio.",
    "analyticsBody": "Ajudam-nos a ver que páginas são usadas e onde os visitantes ficam presos, para as podermos melhorar.",
    "analyticsTitle": "Analíticos",
    "clarityId": "Definido por clarity.ms, o serviço que faz essas medições.",
    "claritySession": "Marca a visita atual.",
    "clarityVisitor": "Reconhece o seu navegador entre visitas, para vermos onde os visitantes ficam presos.",
    "close": "Fechar",
    "colExpiry": "Validade",
    "colName": "Nome",
    "colPurpose": "Finalidade",
    "consentCookie": "As suas escolhas de cookies.",
    "description": "Alguns cookies são necessários para o funcionamento do site. Com a sua autorização, também os usaríamos para perceber como o site é utilizado e para medir o nosso marketing.",
    "expiry12m": "12 meses",
    "expiry13m": "13 meses",
    "expiry15min": "15 minutos",
    "expiry1d": "1 dia",
    "expiry24m": "24 meses",
    "expiry6m": "6 meses",
    "expiry90d": "90 dias",
    "expiryStorage": "Armazenamento local, até que o limpe",
    "gaSession": "Mantém uma visita junta, para que páginas lidas seguidas contem como uma.",
    "gaVisitor": "Se já esteve aqui antes, para que um visitante que regressa não seja contado como novo.",
    "introBody": "Os cookies necessários estão sempre ativos, porque o site não funciona sem eles. Tudo o resto fica desativado até que os ative, e pode alterar a sua escolha a qualquer momento.",
    "introTitle": "Como utilizamos os cookies",
    "localeCookie": "O idioma que escolheu para o site.",
    "manage": "Gerir preferências",
    "marketingBody": "Usados para medir a nossa publicidade e mostrar conteúdos relevantes para si.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Reconhece o seu navegador, para medirmos a nossa publicidade no Facebook e no Instagram.",
    "metaClick": "Definido quando chega através de um anúncio no Facebook ou no Instagram.",
    "necessaryBody": "Guardam o idioma escolhido, mantêm o registo que está a concluir e guardam a sua escolha de cookies. Não podem ser desativados.",
    "necessaryTitle": "Estritamente necessários",
    "prefTitle": "Preferências de cookies",
    "preferencesBody": "Guardam as escolhas opcionais que faz, para que o site fique como o deixou. Também guardam a sua conversa com o suporte, para a retomar onde a deixou.",
    "preferencesTitle": "Preferências",
    "rejectAll": "Recusar os não essenciais",
    "remarketingId": "Reconhece o seu navegador noutros sites, para mostrarmos os nossos anúncios a quem nos visitou.",
    "remarketingProbe": "Verifica se o seu navegador aceita cookies de publicidade.",
    "save": "Guardar preferências",
    "signupState": "O registo que está a concluir.",
    "supportChat": "A sua conversa com o apoio, para continuar onde parou.",
    "title": "Utilizamos cookies"
  },
  "pl": {
    "acceptAll": "Zaakceptuj wszystkie",
    "adsClick": "Łączy rejestrację z reklamą, z której pochodzi.",
    "adsFromAd": "Ustawiany, gdy trafiasz tu z reklamy Google, i łączy tę wizytę z tą reklamą.",
    "analyticsBody": "Pomagają nam zobaczyć, które strony są używane i gdzie odwiedzający się zatrzymują, abyśmy mogli je ulepszyć.",
    "analyticsTitle": "Analityczne",
    "clarityId": "Ustawiany przez clarity.ms, usługę wykonującą te pomiary.",
    "claritySession": "Oznacza bieżącą wizytę.",
    "clarityVisitor": "Rozpoznaje przeglądarkę między wizytami, abyśmy widzieli, gdzie odwiedzający się zatrzymują.",
    "close": "Zamknij",
    "colExpiry": "Wygasa",
    "colName": "Nazwa",
    "colPurpose": "Cel",
    "consentCookie": "Twoje wybory dotyczące plików cookie.",
    "description": "Niektóre pliki cookie są niezbędne do działania strony. Za Twoją zgodą używalibyśmy ich również, aby rozumieć, jak strona jest używana, i mierzyć nasz marketing.",
    "expiry12m": "12 miesięcy",
    "expiry13m": "13 miesięcy",
    "expiry15min": "15 minut",
    "expiry1d": "1 dzień",
    "expiry24m": "24 miesiące",
    "expiry6m": "6 miesięcy",
    "expiry90d": "90 dni",
    "expiryStorage": "Pamięć lokalna, do wyczyszczenia",
    "gaSession": "Łączy jedną wizytę, aby strony czytane po kolei liczyły się jako jedna.",
    "gaVisitor": "Czy ta przeglądarka była tu wcześniej, aby powracający odwiedzający nie był liczony jako nowy.",
    "introBody": "Niezbędne pliki cookie są zawsze włączone, ponieważ bez nich strona nie działa. Wszystko inne pozostaje wyłączone, dopóki tego nie włączysz, a swój wybór możesz zmienić w każdej chwili.",
    "introTitle": "Jak używamy plików cookie",
    "localeCookie": "Wybrany przez Ciebie język strony.",
    "manage": "Zarządzaj ustawieniami",
    "marketingBody": "Służą do mierzenia naszych reklam i pokazywania treści istotnych dla Ciebie.",
    "marketingTitle": "Marketingowe",
    "metaBrowser": "Rozpoznaje przeglądarkę, abyśmy mogli mierzyć naszą reklamę na Facebooku i Instagramie.",
    "metaClick": "Ustawiany, gdy trafiasz tu z reklamy na Facebooku lub Instagramie.",
    "necessaryBody": "Zapamiętują wybrany język, zachowują rozpoczętą rejestrację i przechowują Twój wybór dotyczący plików cookie. Nie można ich wyłączyć.",
    "necessaryTitle": "Niezbędne",
    "prefTitle": "Ustawienia plików cookie",
    "preferencesBody": "Zapamiętują opcjonalne wybory, aby strona działała tak, jak ją zostawiłeś. Zachowują też rozmowę z pomocą techniczną, aby można było ją kontynuować.",
    "preferencesTitle": "Preferencje",
    "rejectAll": "Odrzuć zbędne",
    "remarketingId": "Rozpoznaje przeglądarkę na innych stronach, abyśmy mogli pokazywać reklamy osobom, które nas odwiedziły.",
    "remarketingProbe": "Sprawdza, czy przeglądarka w ogóle akceptuje reklamowe pliki cookie.",
    "save": "Zapisz ustawienia",
    "signupState": "Rejestracja, którą właśnie wypełniasz.",
    "supportChat": "Twoja rozmowa ze wsparciem, aby kontynuować ją w miejscu, w którym została przerwana.",
    "title": "Używamy plików cookie"
  },
  "ro": {
    "acceptAll": "Acceptă toate",
    "adsClick": "Leagă o înregistrare de anunțul din care a venit.",
    "adsFromAd": "Setat când ajungeți dintr-un anunț Google și leagă această vizită de el.",
    "analyticsBody": "Ne ajută să vedem ce pagini sunt folosite și unde se blochează vizitatorii, ca să le putem îmbunătăți.",
    "analyticsTitle": "Analitice",
    "clarityId": "Setat de clarity.ms, serviciul care face aceste măsurători.",
    "claritySession": "Marchează vizita curentă.",
    "clarityVisitor": "Vă recunoaște browserul între vizite, ca să vedem unde se blochează vizitatorii.",
    "close": "Închide",
    "colExpiry": "Expiră",
    "colName": "Nume",
    "colPurpose": "Scop",
    "consentCookie": "Alegerile dumneavoastră privind cookie-urile.",
    "description": "Unele module cookie sunt necesare pentru funcționarea site-ului. Cu permisiunea dumneavoastră le-am folosi și pentru a înțelege cum este utilizat site-ul și pentru a măsura marketingul nostru.",
    "expiry12m": "12 luni",
    "expiry13m": "13 luni",
    "expiry15min": "15 minute",
    "expiry1d": "1 zi",
    "expiry24m": "24 de luni",
    "expiry6m": "6 luni",
    "expiry90d": "90 de zile",
    "expiryStorage": "Stocare locală, până la ștergere",
    "gaSession": "Grupează o vizită, astfel încât paginile citite una după alta să conteze ca una.",
    "gaVisitor": "Dacă ați mai fost aici, astfel încât un vizitator care revine să nu fie numărat ca nou.",
    "introBody": "Modulele cookie necesare sunt mereu active, deoarece site-ul nu poate funcționa fără ele. Restul rămâne dezactivat până când le activați, iar alegerea poate fi schimbată oricând.",
    "introTitle": "Cum folosim modulele cookie",
    "localeCookie": "Limba pe care ați ales-o pentru site.",
    "manage": "Gestionează preferințele",
    "marketingBody": "Folosite pentru a măsura publicitatea noastră și a afișa conținut relevant pentru dumneavoastră.",
    "marketingTitle": "Marketing",
    "metaBrowser": "Vă recunoaște browserul, ca să putem măsura reclamele noastre pe Facebook și Instagram.",
    "metaClick": "Setat când ajungeți dintr-un anunț de pe Facebook sau Instagram.",
    "necessaryBody": "Rețin limba aleasă, păstrează înregistrarea în curs și salvează alegerea privind cookie-urile. Acestea nu pot fi dezactivate.",
    "necessaryTitle": "Strict necesare",
    "prefTitle": "Preferințe pentru cookie-uri",
    "preferencesBody": "Rețin opțiunile facultative pe care le alegeți, astfel încât site-ul să rămână așa cum l-ați lăsat. Păstrează și conversația dvs. cu echipa de asistență, ca să o puteți relua de unde ați rămas.",
    "preferencesTitle": "Preferințe",
    "rejectAll": "Respinge cele neesențiale",
    "remarketingId": "Vă recunoaște browserul pe alte site-uri, ca să arătăm reclamele noastre celor care ne-au vizitat.",
    "remarketingProbe": "Verifică dacă browserul acceptă cookie-uri publicitare.",
    "save": "Salvează preferințele",
    "signupState": "Înregistrarea pe care o completați.",
    "supportChat": "Conversația dvs. cu asistența, pentru a continua de unde ați rămas.",
    "title": "Folosim module cookie"
  },
  "no": {
    "acceptAll": "Godta alle",
    "adsClick": "Knytter en registrering til annonsen den kom fra.",
    "adsFromAd": "Settes når du kommer fra en Google-annonse, og knytter dette besøket til den.",
    "analyticsBody": "Hjelper oss å se hvilke sider som brukes og hvor besøkende stopper opp, slik at vi kan forbedre dem.",
    "analyticsTitle": "Analyse",
    "clarityId": "Settes av clarity.ms, tjenesten som utfører disse målingene.",
    "claritySession": "Merker besøket du er inne i nå.",
    "clarityVisitor": "Gjenkjenner nettleseren din mellom besøk, så vi ser hvor besøkende står fast.",
    "close": "Lukk",
    "colExpiry": "Utløper",
    "colName": "Navn",
    "colPurpose": "Formål",
    "consentCookie": "Valgene dine om informasjonskapsler.",
    "description": "Noen informasjonskapsler er nødvendige for at nettstedet skal fungere. Med ditt samtykke ville vi også brukt dem til å forstå hvordan nettstedet brukes og til å måle markedsføringen vår.",
    "expiry12m": "12 måneder",
    "expiry13m": "13 måneder",
    "expiry15min": "15 minutter",
    "expiry1d": "1 dag",
    "expiry24m": "24 måneder",
    "expiry6m": "6 måneder",
    "expiry90d": "90 dager",
    "expiryStorage": "Lokal lagring, til du sletter den",
    "gaSession": "Holder ett besøk samlet, slik at sider lest etter hverandre teller som ett.",
    "gaVisitor": "Om du har vært her før, slik at en tilbakevendende besøkende ikke telles som ny.",
    "introBody": "Nødvendige informasjonskapsler er alltid på, fordi nettstedet ikke fungerer uten dem. Alt annet er av til du slår det på, og du kan endre valget ditt når som helst.",
    "introTitle": "Slik bruker vi informasjonskapsler",
    "localeCookie": "Språket du valgte for nettstedet.",
    "manage": "Administrer innstillinger",
    "marketingBody": "Brukes til å måle annonseringen vår og vise innhold som er relevant for deg.",
    "marketingTitle": "Markedsføring",
    "metaBrowser": "Gjenkjenner nettleseren din, slik at vi kan måle annonseringen vår på Facebook og Instagram.",
    "metaClick": "Settes når du kommer fra en annonse på Facebook eller Instagram.",
    "necessaryBody": "Husker språket du valgte, tar vare på registreringen du holder på med, og lagrer valget ditt om informasjonskapsler. Disse kan ikke slås av.",
    "necessaryTitle": "Strengt nødvendige",
    "prefTitle": "Innstillinger for informasjonskapsler",
    "preferencesBody": "Husker valgfrie innstillinger, slik at nettstedet oppfører seg slik du forlot det. De tar også vare på supportsamtalen din, slik at du kan fortsette der du slapp.",
    "preferencesTitle": "Preferanser",
    "rejectAll": "Avvis ikke-nødvendige",
    "remarketingId": "Gjenkjenner nettleseren din på andre nettsteder, så vi kan vise annonsene våre til dem som har besøkt oss.",
    "remarketingProbe": "Sjekker om nettleseren din i det hele tatt godtar annonseinformasjonskapsler.",
    "save": "Lagre innstillinger",
    "signupState": "Registreringen du holder på med.",
    "supportChat": "Samtalen din med kundestøtte, slik at den fortsetter der du slapp.",
    "title": "Vi bruker informasjonskapsler"
  },
  "bg": {
    "acceptAll": "Приемам всички",
    "adsClick": "Свързва регистрацията с рекламата, от която идва.",
    "adsFromAd": "Задава се, когато идвате от реклама в Google, и свързва това посещение с нея.",
    "analyticsBody": "Помагат ни да видим кои страници се използват и къде посетителите се затрудняват, за да ги подобрим.",
    "analyticsTitle": "Аналитични",
    "clarityId": "Задава се от clarity.ms — услугата, която прави тези измервания.",
    "claritySession": "Отбелязва текущото посещение.",
    "clarityVisitor": "Разпознава браузъра ви между посещенията, за да видим къде посетителите се затрудняват.",
    "close": "Затваряне",
    "colExpiry": "Срок",
    "colName": "Име",
    "colPurpose": "Цел",
    "consentCookie": "Вашият избор за бисквитките.",
    "description": "Някои бисквитки са необходими, за да работи сайтът. С вашето съгласие бихме ги използвали и за да разберем как се използва сайтът и да измерим маркетинга си.",
    "expiry12m": "12 месеца",
    "expiry13m": "13 месеца",
    "expiry15min": "15 минути",
    "expiry1d": "1 ден",
    "expiry24m": "24 месеца",
    "expiry6m": "6 месеца",
    "expiry90d": "90 дни",
    "expiryStorage": "Локално хранилище, докато не го изчистите",
    "gaSession": "Свързва едно посещение, за да се броят последователно четените страници като едно.",
    "gaVisitor": "Дали вече сте били тук, за да не се брои завърналият се посетител като нов.",
    "introBody": "Необходимите бисквитки са винаги включени, защото без тях сайтът не работи. Всичко останало остава изключено, докато вие не го включите, и можете да промените избора си по всяко време.",
    "introTitle": "Как използваме бисквитките",
    "localeCookie": "Езикът, който сте избрали за сайта.",
    "manage": "Управление на настройките",
    "marketingBody": "Използват се, за да измерваме рекламата си и да показваме съдържание, което е подходящо за вас.",
    "marketingTitle": "Маркетингови",
    "metaBrowser": "Разпознава браузъра ви, за да измерваме рекламата си във Facebook и Instagram.",
    "metaClick": "Задава се, когато идвате от реклама във Facebook или Instagram.",
    "necessaryBody": "Запомнят избрания език, пазят започнатата регистрация и съхраняват избора ви за бисквитки. Не могат да бъдат изключени.",
    "necessaryTitle": "Строго необходими",
    "prefTitle": "Настройки за бисквитки",
    "preferencesBody": "Запомнят незадължителните ви избори, за да работи сайтът така, както сте го оставили. Запазват и разговора ви с поддръжката, за да го продължите оттам, докъдето сте стигнали.",
    "preferencesTitle": "Предпочитания",
    "rejectAll": "Отхвърляне на несъществените",
    "remarketingId": "Разпознава браузъра ви в други сайтове, за да показваме рекламите си на посещавалите ни.",
    "remarketingProbe": "Проверява дали браузърът ви изобщо приема рекламни бисквитки.",
    "save": "Запазване на настройките",
    "signupState": "Регистрацията, която попълвате.",
    "supportChat": "Вашият разговор с поддръжката, за да продължи оттам, докъдето сте стигнали.",
    "title": "Използваме бисквитки"
  },
  "tr": {
    "acceptAll": "Tümünü kabul et",
    "adsClick": "Bir kaydı, geldiği reklamla ilişkilendirir.",
    "adsFromAd": "Bir Google reklamından geldiğinizde ayarlanır ve bu ziyareti o reklamla ilişkilendirir.",
    "analyticsBody": "Hangi sayfaların kullanıldığını ve ziyaretçilerin nerede takıldığını görmemize yardımcı olur, böylece onları iyileştirebiliriz.",
    "analyticsTitle": "Analitik",
    "clarityId": "Bu ölçümleri yapan clarity.ms hizmeti tarafından ayarlanır.",
    "claritySession": "Şu anki ziyareti işaretler.",
    "clarityVisitor": "Ziyaretler arasında tarayıcınızı tanır; böylece ziyaretçilerin nerede takıldığını görürüz.",
    "close": "Kapat",
    "colExpiry": "Süre",
    "colName": "Ad",
    "colPurpose": "Amaç",
    "consentCookie": "Çerez tercihleriniz.",
    "description": "Bazı çerezler sitenin çalışması için gereklidir. İzniniz olursa bunları sitenin nasıl kullanıldığını anlamak ve pazarlamamızı ölçmek için de kullanırdık.",
    "expiry12m": "12 ay",
    "expiry13m": "13 ay",
    "expiry15min": "15 dakika",
    "expiry1d": "1 gün",
    "expiry24m": "24 ay",
    "expiry6m": "6 ay",
    "expiry90d": "90 gün",
    "expiryStorage": "Yerel depolama, siz silene kadar",
    "gaSession": "Tek bir ziyareti bir arada tutar; art arda okunan sayfalar tek ziyaret sayılır.",
    "gaVisitor": "Daha önce burada bulunup bulunmadığınız; böylece geri dönen ziyaretçi yeni sayılmaz.",
    "introBody": "Gerekli çerezler her zaman açıktır, çünkü site onlarsız çalışmaz. Diğer her şey siz açana kadar kapalı kalır ve seçiminizi istediğiniz zaman değiştirebilirsiniz.",
    "introTitle": "Çerezleri nasıl kullanıyoruz",
    "localeCookie": "Site için seçtiğiniz dil.",
    "manage": "Tercihleri yönet",
    "marketingBody": "Reklamlarımızı ölçmek ve sizinle ilgili içerik göstermek için kullanılır.",
    "marketingTitle": "Pazarlama",
    "metaBrowser": "Facebook ve Instagram reklamlarımızı ölçebilmemiz için tarayıcınızı tanır.",
    "metaClick": "Facebook veya Instagram'daki bir reklamdan geldiğinizde ayarlanır.",
    "necessaryBody": "Seçtiğiniz dili hatırlar, sürmekte olan kaydınızı saklar ve çerez tercihinizi tutar. Bunlar kapatılamaz.",
    "necessaryTitle": "Kesinlikle gerekli",
    "prefTitle": "Çerez tercihleri",
    "preferencesBody": "Yaptığınız isteğe bağlı seçimleri hatırlar, böylece site bıraktığınız gibi davranır. Ayrıca destek sohbetinizi saklar, böylece kaldığınız yerden devam edebilirsiniz.",
    "preferencesTitle": "Tercihler",
    "rejectAll": "Zorunlu olmayanları reddet",
    "remarketingId": "Tarayıcınızı başka sitelerde tanır; böylece bizi ziyaret edenlere reklamlarımızı gösterebiliriz.",
    "remarketingProbe": "Tarayıcınızın reklam çerezlerini kabul edip etmediğini kontrol eder.",
    "save": "Tercihleri kaydet",
    "signupState": "Tamamlamakta olduğunuz kayıt.",
    "supportChat": "Destek sohbetiniz, kaldığınız yerden devam etmesi için.",
    "title": "Çerez kullanıyoruz"
  },
  "lt": {
    "acceptAll": "Priimti visus",
    "adsClick": "Susieja registraciją su skelbimu, iš kurio ji atėjo.",
    "adsFromAd": "Nustatomas, kai atvykstate iš „Google“ skelbimo, ir susieja šį apsilankymą su juo.",
    "analyticsBody": "Padeda matyti, kurie puslapiai naudojami ir kur lankytojai užstringa, kad galėtume juos patobulinti.",
    "analyticsTitle": "Analitiniai",
    "clarityId": "Nustato clarity.ms – paslauga, atliekanti šiuos matavimus.",
    "claritySession": "Pažymi dabartinį apsilankymą.",
    "clarityVisitor": "Atpažįsta jūsų naršyklę tarp apsilankymų, kad matytume, kur lankytojai užstringa.",
    "close": "Uždaryti",
    "colExpiry": "Galiojimas",
    "colName": "Pavadinimas",
    "colPurpose": "Paskirtis",
    "consentCookie": "Jūsų sprendimai dėl slapukų.",
    "description": "Kai kurie slapukai būtini, kad svetainė veiktų. Gavę jūsų sutikimą, juos naudotume ir tam, kad suprastume, kaip svetainė naudojama, ir įvertintume savo rinkodarą.",
    "expiry12m": "12 mėnesių",
    "expiry13m": "13 mėnesių",
    "expiry15min": "15 minučių",
    "expiry1d": "1 diena",
    "expiry24m": "24 mėnesiai",
    "expiry6m": "6 mėnesiai",
    "expiry90d": "90 dienų",
    "expiryStorage": "Vietinė saugykla, kol ištrinsite",
    "gaSession": "Sujungia vieną apsilankymą, kad iš eilės skaitomi puslapiai būtų skaičiuojami kaip vienas.",
    "gaVisitor": "Ar jau lankėtės čia anksčiau, kad grįžtantis lankytojas nebūtų skaičiuojamas kaip naujas.",
    "introBody": "Būtini slapukai visada įjungti, nes be jų svetainė neveikia. Visa kita lieka išjungta, kol patys neįjungsite, o savo pasirinkimą galite pakeisti bet kada.",
    "introTitle": "Kaip naudojame slapukus",
    "localeCookie": "Jūsų pasirinkta svetainės kalba.",
    "manage": "Tvarkyti nustatymus",
    "marketingBody": "Naudojami mūsų reklamai įvertinti ir jums aktualiam turiniui rodyti.",
    "marketingTitle": "Rinkodaros",
    "metaBrowser": "Atpažįsta jūsų naršyklę, kad galėtume įvertinti savo reklamą „Facebook“ ir „Instagram“.",
    "metaClick": "Nustatomas, kai atvykstate iš „Facebook“ ar „Instagram“ skelbimo.",
    "necessaryBody": "Įsimena pasirinktą kalbą, išsaugo pradėtą registraciją ir jūsų sprendimą dėl slapukų. Jų išjungti negalima.",
    "necessaryTitle": "Būtinieji",
    "prefTitle": "Slapukų nustatymai",
    "preferencesBody": "Įsimena pasirenkamus nustatymus, kad svetainė veiktų taip, kaip ją palikote. Jie taip pat išsaugo jūsų pokalbį su pagalbos tarnyba, kad galėtumėte jį tęsti.",
    "preferencesTitle": "Nuostatos",
    "rejectAll": "Atmesti nebūtinus",
    "remarketingId": "Atpažįsta jūsų naršyklę kitose svetainėse, kad galėtume rodyti reklamą mus aplankiusiems.",
    "remarketingProbe": "Patikrina, ar jūsų naršyklė apskritai priima reklamos slapukus.",
    "save": "Išsaugoti nustatymus",
    "signupState": "Registracija, kurią šiuo metu pildote.",
    "supportChat": "Jūsų pokalbis su pagalbos tarnyba, kad galėtumėte tęsti nuo tos vietos, kur baigėte.",
    "title": "Naudojame slapukus"
  }
};
